// ABOUTME: Drafty "D" icon with lightning bolt
// ABOUTME: Extracted from the full logo for use in compact spaces like sidebar

interface DraftyIconProps {
  className?: string
  size?: number
}

export function DraftyIcon({ className = "", size = 32 }: DraftyIconProps) {
  const colorClass = className.includes("text-") ? className : `text-black dark:text-white ${className}`

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 120 120"
      width={size}
      height={size}
      className={colorClass}
      aria-label="Drafty"
    >
      <path
        d="M103.31,18.09C90.63,5.93,72.4,0,50.61,0H6.01C2.7,0,0,2.64,0,5.95v108.01c0,3.31,2.71,6.04,6.02,6.04h44.91c21.7,0,39.92-7.33,52.69-19.58,11.13-10.61,16.38-25.27,16.38-41.43s-5.2-29.94-16.69-40.89ZM52.01,104v-37h-21.83l29.83-51v33h23.81l-31.81,55Z"
        fill="currentColor"
      />
    </svg>
  )
}
